var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4135 9.44957C16.5898 9.36123 16.738 9.2256 16.8416 9.05785C16.9451 8.8901 17 8.69684 17 8.49969C17 8.30254 16.9451 8.10929 16.8416 7.94153C16.738 7.77378 16.5898 7.63815 16.4135 7.54981L1.538 0.112308C1.35355 0.0200236 1.14623 -0.0165894 0.941336 0.00693584C0.736438 0.030461 0.542816 0.113107 0.384089 0.244793C0.225361 0.376479 0.108393 0.551511 0.0474486 0.748538C-0.0134955 0.945565 -0.0157795 1.15607 0.0408761 1.35437L1.55924 6.66688C1.62276 6.88891 1.75688 7.08421 1.94132 7.22321C2.12576 7.3622 2.35046 7.43732 2.58141 7.43719L7.43828 7.43719C7.72008 7.43719 7.99034 7.54913 8.18961 7.74839C8.38887 7.94765 8.50082 8.2179 8.50082 8.49969C8.50082 8.78148 8.38887 9.05173 8.18961 9.25099C7.99034 9.45025 7.72008 9.56219 7.43828 9.56219H2.58141C2.35046 9.56206 2.12576 9.63718 1.94132 9.77618C1.75688 9.91517 1.62276 10.1105 1.55924 10.3325L0.0419385 15.645C-0.0148293 15.8432 -0.0126822 16.0537 0.0481176 16.2508C0.108917 16.4478 0.225743 16.6229 0.384346 16.7547C0.542949 16.8865 0.736475 16.9693 0.941324 16.993C1.14617 17.0167 1.35349 16.9802 1.538 16.8881L16.4135 9.45063V9.44957Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.7c4a0e1867e2ea1ee623d7bed48031ab.svg";
export { ForwardRef as ReactComponent };